import { useLocation } from "react-router-dom";
import { RefreshCw, Loader2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

/** News-list footer: «تحميل المزيد» shown once; after the first successful tap the list auto-loads near the end.
 *  A visually-hidden <a rel="next" href="?page=N"> stays for crawlers. */
export default function LoadMoreFooter({ feed, testId = "load-more" }) {
    const { t } = useLang();
    const { pathname } = useLocation();
    const nextHref = `${pathname}?page=${feed.nextPage}`;
    const onClick = (e) => { e.preventDefault(); if (!feed.loading) feed.loadMore(); };
    const showButton = !feed.loading && feed.hasMore && !feed.error && !feed.autoMode;
    return (
        <div className="mt-6 text-center min-h-[44px]" data-testid={`${testId}-footer`} data-auto={feed.autoMode ? "1" : "0"}>
            <div ref={feed.sentinelRef} aria-hidden="true" className="h-px" data-testid={`${testId}-sentinel`} />
            {feed.loading && (
                <span className="inline-flex items-center gap-2 text-sm text-gray-500" role="status" data-testid={`${testId}-loading`}><Loader2 className="w-4 h-4 animate-spin" /> {t("loadingMore")}</span>
            )}
            {showButton && (
                <a href={nextHref} rel="next" onClick={onClick}
                    className="inline-flex items-center gap-2 min-h-[44px] px-6 rounded-sm border text-sm font-bold transition-colors border-gray-300 dark:border-gray-700 text-brand-black dark:text-gray-100 hover:border-brand-red hover:text-brand-red"
                    data-testid={testId}>
                    <RefreshCw className="w-4 h-4" /> {t("loadMore")}
                </a>
            )}
            {feed.error && !feed.loading && (
                <div className="inline-flex flex-wrap items-center justify-center gap-3 text-sm" data-testid={`${testId}-error`}>
                    <span className="text-red-600">{t("loadMoreFail")}</span>
                    <button type="button" onClick={onClick} className="inline-flex items-center gap-1.5 min-h-[40px] px-4 rounded-sm border border-brand-red text-brand-red font-bold hover:bg-red-50 dark:hover:bg-red-950/30" data-testid={`${testId}-retry`}>
                        <RefreshCw className="w-4 h-4" /> {t("retry")}
                    </button>
                </div>
            )}
            {!feed.loading && !feed.hasMore && feed.items.length > 0 && (
                <span className="text-sm text-gray-400" data-testid={`${testId}-end`}>{t("noMore")}</span>
            )}
            {feed.hasMore && !showButton && <a href={nextHref} rel="next" className="sr-only" tabIndex={-1} data-testid={`${testId}-next-link`}>{t("loadMore")}</a>}
        </div>
    );
}
